// Libs
import axios, { AxiosResponse } from "axios";
// App
import { ADDRESS_URL } from "./address.constants";
import { AddressDetails } from "./address.interfaces";
import {
  useAxiosPostRequest,
  AxiosHookResponse,
  useAxiosPutRequest,
} from "../../utils/axios-request.hooks";
import { API_COMMON_BASE_URL } from "../../utils/api.constants";

/**
 * Create address api hook
 */
export const useCreateAddress = (): AxiosHookResponse<AddressDetails, void> => {
  const url = `${API_COMMON_BASE_URL}/${ADDRESS_URL}`;

  return useAxiosPostRequest(url);
};

/**
 * Update address api hook
 */
export const useUpdateAddress = (): AxiosHookResponse<AddressDetails, void> => {
  const url = `${API_COMMON_BASE_URL}/${ADDRESS_URL}`;

  return useAxiosPutRequest(url);
};

/**
 * Delete address api
 */
export const deleteAddress = (id: number): Promise<AxiosResponse<void>> => {
  const url = `${API_COMMON_BASE_URL}/${ADDRESS_URL}/${id}`;

  return axios.delete(url);
};
